import { LocaleValue } from '@silvertours/common-landingpages-view';
import {
  CardContainer,
  Label,
  Line,
  MonthContainer,
  PriceWrapper,
  NoDataTextWrapper,
  ForbiddenIcon,
  PiggyBankIcon,
  ImageWrapper,
  TextBlock,
} from './Graph.styles';
import { useLocale, usePriceFn } from '../Runtime';

export const CheapestMonthIndicator = ({
  selected,
  cheapestMonthLabel,
}: {
  selected?: boolean;
  cheapestMonthLabel?: string;
}) => (
  <>
    <ImageWrapper selected={selected}>
      <PiggyBankIcon />
    </ImageWrapper>
    <Label>{cheapestMonthLabel}</Label>
  </>
);

type Props = {
  date: string;
  priceMedian: number;
  priceMax: number;
  priceMin: number;
  cheapestMonth?: boolean;
  onClick: () => void;
  translations?: {
    averagePrice: string;
    buttonText: string;
    priceRange: string;
    cheapestMonthLabel: string;
    noDataText: string;
  };
};

const getMonthName = (date: string, locale: LocaleValue) => {
  const dateObj = new Date(Date.parse(date));
  const month = new Intl.DateTimeFormat(locale, { month: 'long' }).format(
    dateObj,
  );
  return month[0].toUpperCase() + month.slice(1);
};

export const Card = ({
  date,
  priceMedian,
  priceMax,
  priceMin,
  cheapestMonth = false,
  onClick,
  translations,
}: Props) => {
  const { locale } = useLocale();
  const priceFn = usePriceFn();
  const pricesAreAvailable = priceMedian !== 0;
  const { averagePrice, priceRange, cheapestMonthLabel } = translations || {};

  const formattedPrice = {
    min: priceFn({ amount: priceMin, currency: 'EUR' }, locale),
    max: priceFn({ amount: priceMax, currency: 'EUR' }, locale),
    median: priceFn({ amount: priceMedian, currency: 'EUR' }, locale),
  };

  return (
    <CardContainer onClick={onClick} pricesAreAvailable={pricesAreAvailable}>
      {cheapestMonth && (
        <CheapestMonthIndicator
          selected
          cheapestMonthLabel={cheapestMonthLabel}
        />
      )}
      <TextBlock>
        <MonthContainer>{getMonthName(date, locale)}</MonthContainer>
        <Line />
        {pricesAreAvailable ? (
          <>
            <div>{averagePrice}</div>
            <PriceWrapper>{formattedPrice.median}</PriceWrapper>
            <div>{priceRange}</div>
            <PriceWrapper>
              {formattedPrice.min} – {formattedPrice.max}
            </PriceWrapper>
          </>
        ) : (
          <NoDataTextWrapper textColor="grey" selected>
            <ForbiddenIcon />
            <span>{translations?.noDataText}</span>
          </NoDataTextWrapper>
        )}
      </TextBlock>
    </CardContainer>
  );
};
